module.exports = __webpack_public_path__ + "assets/img/26.874929c6.png";